module.exports = __webpack_public_path__ + "assets/images/games/bg_track_sky.115e4cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/games/carrot-game/bg_track_sky.jpg
// module id = 1636
// module chunks = 1